import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN AUTH HEADER
// ================================

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}


// ================================
// ADMIN COURSE APIs
// ================================


// ================================
// 1) GET COURSES LIST
// ================================

export async function getCoursesApi(payload) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/courses/list`,
      {
        page: payload?.page || 1,
        limit: payload?.limit || 5,
        search: payload?.search || "",
        course_typ: payload?.course_typ || "",
        category: payload?.category || "",
        creator_id: payload?.creator_id || "",
      },
      {
        ...getAdminAuthConfig(),
        headers: {
          ...getAdminAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Get Courses Error:", err);

    return {
      status: false,
      type: "danger",
      success:
        err?.response?.data?.success ||
        err?.response?.data?.message ||
        err?.message ||
        "Courses fetch failed",
    };
  }
}


// ================================
// 2) GET COURSE STATS
// ================================

export async function getCourseStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/courses/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Course Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Course stats fetch failed",
    };
  }
}


// ================================
// 3) VIEW COURSE
// ================================

export async function getCourseApi(courseId) {
  try {
    const fd = new FormData();

    fd.append("course_id", courseId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/courses/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Course Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Course fetch failed",
    };
  }
}


// ================================
// 4) CREATE COURSE
// ================================

export async function createCourseApi(payload) {
  try {
    const fd = new FormData();

    // ================================
    // BASIC INFORMATION
    // ================================

    fd.append("title", payload.title || "");

    fd.append(
      "category",
      payload.category || ""
    );

    fd.append(
      "course_typ",
      payload.course_typ || ""
    );

    fd.append(
      "creator_id",
      payload.creator_id || ""
    );

    // ================================
    // SEO
    // ================================

    fd.append(
      "meta_title",
      payload.meta_title || ""
    );

    fd.append(
      "meta_keywords",
      payload.meta_keywords || ""
    );

    // ================================
    // COURSE DETAILS
    // ================================

    fd.append(
      "about",
      payload.about || ""
    );

    fd.append(
      "details",
      payload.details || ""
    );

    fd.append(
      "course_duration",
      payload.course_duration ?? ""
    );

    fd.append(
      "course_velidity",
      payload.course_velidity || ""
    );

    fd.append(
      "course_language",
      payload.course_language || ""
    );

    fd.append(
      "course_certification",
      payload.course_certification || ""
    );

    // ================================
    // PRICING
    // ================================

    fd.append(
      "price",
      payload.price ?? ""
    );

    fd.append(
      "gst",
      payload.gst ?? ""
    );

    fd.append(
      "discount",
      payload.discount ?? ""
    );

    fd.append(
      "discount_type",
      payload.discount_type || ""
    );

    fd.append(
      "gtotal_price",
      payload.gtotal_price ?? ""
    );

    // ================================
    // MEDIA
    // ================================

    fd.append(
      "course_icon",
      payload.course_icon || ""
    );

    fd.append(
      "course_image",
      payload.course_image || ""
    );

    fd.append(
      "course_video",
      payload.course_video || ""
    );

    // ================================
    // FEATURES
    // ================================

    fd.append(
      "course_features",
      payload.course_features || ""
    );

    fd.append(
      "course_incl_features",
      payload.course_incl_features || ""
    );

    // ================================
    // MENTOR
    // ================================

    fd.append(
      "course_mentor",
      payload.course_mentor || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/courses/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Course Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Course creation failed",
    };
  }
}


// ================================
// 5) UPDATE COURSE
// ================================

export async function updateCourseApi(payload) {
  try {
    const fd = new FormData();

    // ================================
    // COURSE ID
    // ================================

    fd.append(
      "course_id",
      payload.course_id || ""
    );

    // ================================
    // BASIC INFORMATION
    // ================================

    fd.append(
      "title",
      payload.title || ""
    );

    fd.append(
      "category",
      payload.category || ""
    );

    fd.append(
      "course_typ",
      payload.course_typ || ""
    );

    fd.append(
      "creator_id",
      payload.creator_id || ""
    );

    // ================================
    // SEO
    // ================================

    fd.append(
      "meta_title",
      payload.meta_title || ""
    );

    fd.append(
      "meta_keywords",
      payload.meta_keywords || ""
    );

    // ================================
    // COURSE DETAILS
    // ================================

    fd.append(
      "about",
      payload.about || ""
    );

    fd.append(
      "details",
      payload.details || ""
    );

    fd.append(
      "course_duration",
      payload.course_duration ?? ""
    );

    fd.append(
      "course_velidity",
      payload.course_velidity || ""
    );

    fd.append(
      "course_language",
      payload.course_language || ""
    );

    fd.append(
      "course_certification",
      payload.course_certification || ""
    );

    // ================================
    // PRICING
    // ================================

    fd.append(
      "price",
      payload.price ?? ""
    );

    fd.append(
      "gst",
      payload.gst ?? ""
    );

    fd.append(
      "discount",
      payload.discount ?? ""
    );

    fd.append(
      "discount_type",
      payload.discount_type || ""
    );

    fd.append(
      "gtotal_price",
      payload.gtotal_price ?? ""
    );

    // ================================
    // MEDIA
    // ================================

    fd.append(
      "course_icon",
      payload.course_icon || ""
    );

    fd.append(
      "course_image",
      payload.course_image || ""
    );

    fd.append(
      "course_video",
      payload.course_video || ""
    );

    // ================================
    // FEATURES
    // ================================

    fd.append(
      "course_features",
      payload.course_features || ""
    );

    fd.append(
      "course_incl_features",
      payload.course_incl_features || ""
    );

    // ================================
    // MENTOR
    // ================================

    fd.append(
      "course_mentor",
      payload.course_mentor || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/courses/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Course Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Course update failed",
    };
  }
}


// ================================
// 6) DELETE COURSE
// ================================

export async function deleteCourseApi(courseId) {
  try {
    const fd = new FormData();

    fd.append(
      "course_id",
      courseId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/courses/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Course Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Course deletion failed",
    };
  }
}